import { render, staticRenderFns } from "./FlatsTable.vue?vue&type=template&id=7b317695&scoped=true"
import script from "./FlatsTable.vue?vue&type=script&lang=js"
export * from "./FlatsTable.vue?vue&type=script&lang=js"
import style0 from "./FlatsTable.vue?vue&type=style&index=0&id=7b317695&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b317695",
  null
  
)

export default component.exports